import React from "react";
import { EditProfile } from "features/Profile";

const MyProfilePage = () => <EditProfile />;

export default MyProfilePage;
